<template>
  <div id="profile_page" class="content" v-if="user">
    <div class="container">
     
      <section class="main_content">
        <div class="info_block">
          <div class="main_info">
            <h4 class="info_block_heading">
              {{ $t("profile.contact_info.heading") }}
            </h4>
            <p class="info_block_desc">{{ $t("profile.contact_info.why_explain") }}</p>
            <div class="fields_container">
              <div class="field">
                <h5>{{ $t("profile.contact_info.your_city") }}:</h5>
                <select id="city" v-model="user.contacts.city" @change="saveUserData">
                  <option v-for="city in dicts.cities" :value="city.id" :key="city.id">{{ city.name }}</option>
                </select>
                <p>&nbsp;</p>
                <div class="buttons">
                  <div class="button dropdown"></div>
                </div>
              </div>

              <div class="field" @click.stop="start_change_phone">
                <h5 v-show="change_phone_step === 0">{{ $t("profile.contact_info.cell_phone") }}:</h5>
                <p id="phone" v-show="change_phone_step === 0">
                  {{ user.phone }}
                </p>
                <div class="edit" @click.stop="start_change_phone" v-show="change_phone_step === 0">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 528.899 528.899"><path d="M328.883 89.125l107.59 107.589-272.34 272.34L56.604 361.465l272.279-272.34zm189.23-25.948l-47.981-47.981c-18.543-18.543-48.653-18.543-67.259 0l-45.961 45.961 107.59 107.59 53.611-53.611c14.382-14.383 14.382-37.577 0-51.959zM.3 512.69c-1.958 8.812 5.998 16.708 14.811 14.565l119.891-29.069L27.473 390.597.3 512.69z"/></svg>
                </div>
                <div class="change_phone" v-show="change_phone_step > 0">
                  <div class="change_wd" v-show="change_phone_step === 1">
                    <h5>{{ $t("profile.contact_info.cell_phone_replacement.new_phone_number") }}:</h5>
                    <input id="phone" ref="new_tel" type="tel" v-mask="'(###) ### ####'" placeholder="(000) XXX XXXX" v-model="new_phone" v-on:keyup="inputHandlerForPhone" @click.stop="noop">
                    <p>&nbsp;</p>
                    <p class="cp_expl">{{ $t("profile.contact_info.cell_phone_replacement.cp_explain") }}</p>
                  </div>
                    <div class="confirmation" v-show="change_phone_step === 2">
                      <p class="cp_expl">{{ $t("profile.contact_info.cell_phone_replacement.confirmation_expl") }}</p>
                      <div class="change_wd">
                        <h5>{{ $t("profile.contact_info.cell_phone_replacement.code") }}:</h5>
                        <p>&nbsp;</p>
                        <input id="activationPhone" ref="ch_ph_pass" type="tel" placeholder="xxxxxx" v-model="new_phone_pass" v-on:keyup="inputHandlerForPhone" @click.stop="noop">
                        <p class="err" v-if="wrong_pass">{{ $t("profile.contact_info.cell_phone_replacement.wrong_code") }}</p>
                      </div>
                    </div>
                    <div class="buttons">
                      <div class="button next_step" :class="{'active': newPhoneValid}" @click.stop="request_phone_change" v-if="change_phone_step === 1"></div>
                      <div class="button save" :class="{'active': newPhonePassValid}" @click.stop="confirm_change_phone" v-if="change_phone_step === 2"></div>
                      <div class="button cancel" @click.stop="cancel_change_phone"></div>
                    </div>
                </div>
              </div>

              <div class="field" @click.stop="start_change_email">
                <h5 v-show="change_email_step === 0">E-mail:</h5>
                <p id="email" v-show="change_email_step === 0">
                  {{ user.email }}&nbsp;
                </p>
                <div class="edit" @click.stop="start_change_email" v-show="change_email_step === 0">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 528.899 528.899"><path d="M328.883 89.125l107.59 107.589-272.34 272.34L56.604 361.465l272.279-272.34zm189.23-25.948l-47.981-47.981c-18.543-18.543-48.653-18.543-67.259 0l-45.961 45.961 107.59 107.59 53.611-53.611c14.382-14.383 14.382-37.577 0-51.959zM.3 512.69c-1.958 8.812 5.998 16.708 14.811 14.565l119.891-29.069L27.473 390.597.3 512.69z"/></svg>
                </div>
                <div class="change_email" v-show="change_email_step > 0">
                  <div class="change_wd" v-if="change_email_step === 1">
                    <h5>{{ $t("profile.contact_info.email_replacement.new_email") }}:</h5>
                    <p>&nbsp;</p>
                    <input autocomplete="off" id="email" type="text" v-model="new_email" ref="new_email" placeholder="example@mail.com" v-on:keyup="inputHandlerForEmail" @click.stop="noop">
                  </div>
                  <p class="cp_expl" v-show="change_email_step === 2">
                    {{ $t("profile.contact_info.email_replacement.confirmation_expl_1") }} <span>{{ new_email }}</span> {{ $t("profile.contact_info.email_replacement.confirmation_expl_2") }}
                  </p>
                  <div class="buttons">
                    <div class="button next_step" :class="{'active': newEmailValid}" @click.stop="request_email_change" v-if="change_email_step === 1">
                    </div>
                    <div class="button cancel" @click.stop="cancel_change_email" v-if="change_email_step === 1">
                    </div>
                  </div>
                  <div class="delimiter" v-if="change_email_step === 2">
                    <div class="unbordered btn" :class="{'active': newEmailValid}" @click.stop="change_email_step = 0">
                    OK
                  </div>
                    <div class="unbordered btn" @click.stop="change_email_step = 1; new_email = ''">{{ $t("profile.contact_info.email_replacement.enter_other") }}</div>
                    <div class="unbordered"><a href="https://multiplex.ua/faq#support" target="_blank">{{ $t("profile.contact_info.email_replacement.not_received") }}</a></div>
                  </div>
                  <div class="control_butts" v-show="change_email_step === 1"></div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="info_block">
          <h4 class="info_block_heading">{{ $t("profile.your_cards") }}</h4>
          <div class="mp_button" @click="initMP" v-if="!mp_active">{{ $t("profile.show_cards") }}</div>
          <div id="masterpass"></div>
        </div>

        <div class="info_block">
          <div class="body">
            <h4 class="info_block_heading">
              {{ $t("profile.personal_info.heading") }}
            </h4>
            <p class="info_block_desc">{{ $t("profile.personal_info.why_explain") }}</p>
            <div class="fields_container">
                <div class="field" @click.stop="start_change_name">
                  <h5>{{ $t("profile.personal_info.name") }}:</h5>
                  <p v-if="change_name_step === 0 && originalUser.personal.name.length > 0"> {{ originalUser.personal.name }} </p>
                  <p v-if="change_name_step === 0 && originalUser.personal.name.length === 0"> {{ $t("profile.not_seted") }} </p>
                  <p v-if="change_name_step === 1">&nbsp;</p>
                  <input v-if="change_name_step === 1" id="userName" type="text" placeholder="" ref="input_ref_name" v-model="user.personal.name" v-on:keyup="inputHandlerForName" @click.stop="noop">
                  <div class="edit" @click.stop="start_change_name" v-show="change_name_step === 0">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 528.899 528.899"><path d="M328.883 89.125l107.59 107.589-272.34 272.34L56.604 361.465l272.279-272.34zm189.23-25.948l-47.981-47.981c-18.543-18.543-48.653-18.543-67.259 0l-45.961 45.961 107.59 107.59 53.611-53.611c14.382-14.383 14.382-37.577 0-51.959zM.3 512.69c-1.958 8.812 5.998 16.708 14.811 14.565l119.891-29.069L27.473 390.597.3 512.69z"/></svg>
                  </div>
                  <div class="buttons" v-if="change_name_step === 1">
                    <div class="button next_step" @click.stop="apply_change_name"></div>
                    <div class="button cancel" @click.stop="cancel_change_name"></div>
                  </div>
                </div>
                <div class="field" @click.stop="start_change_lastname">
                  <h5>{{ $t("profile.personal_info.surname") }}:</h5>
                  <p v-if="change_lastname_step === 0 && user.personal.surname.length > 0"> {{ user.personal.surname }} </p>
                  <p v-if="change_lastname_step === 0 && user.personal.surname.length === 0"> {{ $t("profile.not_seted") }} </p>
                  <p v-if="change_lastname_step === 1">&nbsp;</p>
                  <input v-if="change_lastname_step === 1" id="userName" type="text" placeholder="" ref="input_ref_lastname" v-model="user.personal.surname" v-on:keyup="inputHandlerForLastName" @click.stop="noop">
                  <div class="edit" @click.stop="start_change_lastname" v-show="change_lastname_step === 0">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 528.899 528.899"><path d="M328.883 89.125l107.59 107.589-272.34 272.34L56.604 361.465l272.279-272.34zm189.23-25.948l-47.981-47.981c-18.543-18.543-48.653-18.543-67.259 0l-45.961 45.961 107.59 107.59 53.611-53.611c14.382-14.383 14.382-37.577 0-51.959zM.3 512.69c-1.958 8.812 5.998 16.708 14.811 14.565l119.891-29.069L27.473 390.597.3 512.69z"/></svg>
                  </div>
                  <div class="buttons" v-if="change_lastname_step === 1">
                    <div class="button next_step" @click.stop="apply_change_lastname"></div>
                    <div class="button cancel" @click.stop="cancel_change_lastname"></div>
                  </div>
                </div>

                <div class="field">
                  <h5>{{ $t("profile.personal_info.marital_status") }}:</h5>
                  <label for="status"></label>
                  <select id="marital_status" v-model="user.personal.family_status" @change="saveUserData">
                    <option v-for="status in dicts.marital_status" :value="status.id" :key="status.id">{{ status.name }}</option>
                  </select>
                  <p>&nbsp;</p>
                  <div class="buttons">
                    <div class="button dropdown"></div>
                  </div>
                </div>
                <div class="field" v-if="birthdayProvided">
                  <h5>{{ $t("profile.personal_info.birthday") }}:</h5>
                  <!-- <input id="birthDate" class="date" type="text" :change="dateIsValid(user.personal.birthday)" v-model="user.personal.birthday" v-mask="'##.##.####'"> -->
                  <p>{{ user.personal.birthday }}</p>
                  <p class="cp_expl cp_expl_btm">{{ $t("profile.personal_info.birthday_hint") }} <a href="https://multiplex.ua/faq#support">{{ $t("profile.personal_info.birthday_hint_link") }}</a></p>
                </div>

                <div class="field" v-else>
                  <h5>{{ $t("profile.personal_info.birthday") }}:</h5>
                  <label for="birthDate"></label>
                  <p>&nbsp;</p>
                  <input id="birthDate" class="date" type="text" :change="dateIsValid(user.personal.birthday)" v-model="user.personal.birthday" v-mask="'##.##.####'" placeholder="В формате DD.MM.YYYY" @click.stop="noop">
                  <div class="buttons" v-if="dateIsFull(user.personal.birthday) && (dateIsValid(user.personal.birthday) && dateIsInPast(user.personal.birthday))">
                    <div class="button next_step" @click.stop="saveUserData"></div>
                  </div>
                  <div class="inv_date" v-if="dateIsFull(user.personal.birthday) && (!dateIsValid(user.personal.birthday) || !dateIsInPast(user.personal.birthday))" >{{ $t("profile.incorrect_date") }}</div>
                </div>
                <div class="field gender">
                  <h5>{{ $t("profile.personal_info.gender") }}:</h5>
                  <select v-model="user.personal.sex" name="gender" id="genderSelect" @change="saveUserData">
                    <option value="">{{ $t("profile.not_seted") }}</option>
                    <option value="M">{{ $t("profile.personal_info.male") }}</option>
                    <option value="F">{{ $t("profile.personal_info.female") }}</option>
                  </select>
                  <p>&nbsp;</p>
                  <div class="buttons">
                    <div class="button dropdown"></div>
                  </div>
                </div>
            </div>
            <h4 class="info_block_heading sub-heading">
              {{ $t("profile.personal_info.family") }}
            </h4>
            <div class="family">
              <div class="fields_container">
                <div class="field" v-for="(child, index) in user.family" :key="index" @click.stop="editChild(index)">
                  <h5>{{ user.family[index].role ? dicts.family_role[user.family[index].role].role : dicts.family_role[0].role }}:</h5>
                  <p>{{user.family[index].name ? user.family[index].name : '&nbsp;'}} {{user.family[index].birthday ? '('+user.family[index].birthday+')' : ''}}</p>
                  <div class="buttons">
                    <div class="button is-hovered" @click.stop="editChild(index)"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 528.899 528.899"><path d="M328.883 89.125l107.59 107.589-272.34 272.34L56.604 361.465l272.279-272.34zm189.23-25.948l-47.981-47.981c-18.543-18.543-48.653-18.543-67.259 0l-45.961 45.961 107.59 107.59 53.611-53.611c14.382-14.383 14.382-37.577 0-51.959zM.3 512.69c-1.958 8.812 5.998 16.708 14.811 14.565l119.891-29.069L27.473 390.597.3 512.69z"></path></svg></div>
                  </div>
                </div>
              </div>
              <div class="member" v-for="(child, index) in user.family" :key="index">
                <div class="family_popup" :data-index="index" v-if="show_family_popup === index">
                  <div class="bg"></div>
                  <div class="pop_up">
                    <div class="head">
                      <p>{{ $t("pop_ups.family_unit.family_member") }}</p>
                      <div class="close" @click="cancelEditChild(index)"></div>
                    </div>
                    <div class="body">
                      <div class="fields_container">
                        <div class="field">
                          <h5>{{ $t("profile.personal_info.marital_status") }}:</h5>
                          <p>&nbsp;</p>
                          <select v-model="user.family[index].role">
                            <option v-for="role in dicts.family_role" :value="role.id" :key="role.id">{{ role.role }}</option>
                          </select>
                          <div class="buttons">
                            <div class="button dropdown"></div>
                          </div>
                        </div>
                        <div class="divider"></div>
                        <div class="field">
                          <h5>{{ $t("profile.personal_info.name") }}:</h5>
                          <p>&nbsp;</p>
                          <input v-model="user.family[index].name" type="text" :placeholder="$t('profile.personal_info.name')">
                        </div>
                        <div class="field">
                          <h5>{{ $t("profile.personal_info.birthday") }}:</h5>
                          <p>&nbsp;</p>
                          <input id="" class="date" type="text" placeholder="DD.MM.YYYY" v-model="user.family[index].birthday" v-mask="'##.##.####'">
                            <p class="inv_date forfamily" v-if="dateIsFull(user.family[index].birthday) && (!dateIsValid(user.family[index].birthday) || !dateIsInPast(user.family[index].birthday))">{{ $t("profile.incorrect_date") }}</p>
                        </div>
                      </div>
                      <div class="buttons-btm">
                        <div class="button-red" @click="savePopupData">{{ $t("profile.save") }}</div>
                        <div class="button-red transparent" @click="cancelEditChild(index)">{{ $t("profile.cancel") }}</div>
                        <div class="button-red transparent" @click="removeChild(index)">
                          <svg width="18" height="20" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M-3-2h24v24H-3z"/><path d="M6.594 0L6.28.281 5.563 1H0v2h1v14c0 1.645 1.355 3 3 3h11c1.645 0 2-1.355 2-3V3h1V1h-5.563L11.72.281 11.406 0H6.594zm.843 2h3.125l.72.719.312.281H15v14c0 .555.555 1 0 1H4c-.555 0-1-.445-1-1V3h3.406l.313-.281L7.437 2zM6 6v9h2V6H6zm4 0v9h2V6h-2z" fill="#FFF" fill-rule="nonzero"/></g></svg>
                          {{ $t("profile.delete") }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span class="button-red" @click="addChild">{{ $t("profile.personal_info.add") }}</span>
            </div>
          </div>
        </div>
        <div class="info_block">
          <h4 class="info_block_heading">
            {{ $t("profile.other_info.heading") }}
          </h4>
          <p class="info_block_desc">{{ $t("profile.other_info.why_explain") }}</p>
          <div class="fields_container">
            <div class="field">
              <h5>{{ $t("profile.other_info.social_status") }}:</h5>
              <select id="social_status" v-model="user.personal.social_status" @change="saveUserData">
                <option v-for="status in dicts.social_status" :key="status.id" :value="status.id">{{ status.name }}</option>
              </select>
              <p>&nbsp;</p>
              <div class="buttons">
                <div class="button dropdown"></div>
              </div>
            </div>
            <div class="field">
              <h5>{{ $t("profile.other_info.favorite_cinema") }}:</h5>
              <select id="cinema" v-model="user.favorites.cinema" @change="saveUserData">
                <option v-for="cinema in dicts.cinemas" :key="cinema.id" :value="cinema.id">{{ cinema.id === 0 ? cinema.name : dicts.citiesById[cinema.city_id].name + ", "+ cinema.name }}</option>
              </select>
              <p>&nbsp;</p>
              <div class="buttons">
                <div class="button dropdown"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="notify-wrapper" v-if="notify">
        <div class="notify-item" :class="notifyState ? 'success' : 'error'">
          <div class="close" @click="closeNotify"></div>
          <p v-if="notifyState">{{ $t("notify.success") }}</p>
          <p v-else>{{ $t("notify.error") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Store from '../../store'
import Moment from 'moment'
import ObjectAssignDeep from 'object-assign-deep'
import DeepEqual from 'deep-equal'

export default {
  data: function () {
    return {
      change_phone_step: 0,
      change_email_step: 0,
      change_name_step: 0,
      change_lastname_step: 0,
      show_family_popup: false,
      new_phone: '',
      new_phone_pass: '',
      wrong_pass: false,
      new_email: '',
      new_name: Store.state.userForProfile.name,
      new_surname: Store.state.userForProfile.surname,
      notify: false,
      notifyState: true,
      mp_active: false
    }
  },
  computed: {
    trimmedNewPhone: function () {
      return '38' + this.new_phone.replace(/[+() ]/g, '')
    },
    newPhoneValid: function () {
      return this.trimmedNewPhone.match(/\d{12}/)
    },
    newEmailValid: function () {
      return this.new_email.match(/[0-9a-z_]+@[0-9a-z_]+\.[a-z]+/i)
    },
    newPhonePassValid: function () {
      return this.new_phone_pass.match(/^\d{6}$/)
    },
    user: function () {
      return Store.state.userForProfile
    },
    dicts: function () {
      return Store.getters.dicts()
    },
    originalUser: function () {
      return Store.state.user
    },
    cities: function () {
      return Store.state.cities
    },
    winScrollTop: function () {
      return Store.state.winScrollTop
    },
    winW: function () {
      return Store.state.winW
    },
    userDataChanged: function () {
      return !DeepEqual(this.user, this.originalUser)
    },
    birthdayProvided: function () {
      return this.originalUser.personal.birthday
    },
    userDataValid: function () {
      var familyBDsAreValid = true
      for (var i = 0; i < this.user.family.length; i++) {
        var currentFamilyMemberBD = this.user.family[i].birthday
        if (!this.dateIsValid(currentFamilyMemberBD) || !this.dateIsInPast(currentFamilyMemberBD)) {
          familyBDsAreValid = false
        }
      }
      // console.log('familyBDsAreValid:', familyBDsAreValid)
      // console.log('BDate Is Valid:', this.dateIsValid(this.user.personal.birthday))
      // console.log('BDate in past:', this.dateIsInPast(this.user.personal.birthday))
      return familyBDsAreValid && this.dateIsValid(this.user.personal.birthday) && (this.dateIsInPast(this.user.personal.birthday) || !this.user.personal.birthday)
    },
    mpInstance: function () {
      return new window.MP()
    },
    uLang: function () {
      return Store.state.uLang
    }
  },
  methods: {
    start_change_phone: function () {
      this.change_phone_step = 1
      setTimeout(() => {
        this.$refs.new_tel.focus()
      }, 10)
    },
    request_phone_change: function () {
      this.$http.post('https://auth.multiplex.ua/ch_login_req', {new_phone: this.trimmedNewPhone}).then(response => {
        if (!response.body.err) {
          this.change_phone_step = 2
          setTimeout(() => {
            this.$refs.ch_ph_pass.focus()
          }, 10)
        }
      })
    },
    confirm_change_phone: function () {
      this.$http.post('https://auth.multiplex.ua/ch_login_confirm', {password: this.new_phone_pass}).then(response => {
        switch (response.body.change_status) {
          case 0:
            alert('Перепрошуємо, з технічних причин не вдалося змінити номер телефону')
            break
          case 1:
            window.location.reload()
            break
          case 2:
            alert('Користувач з таким номером телефону вже існує')
            break
        }
      }, response => {
        this.wrong_pass = true
      })
    },
    start_change_email: function () {
      this.change_email_step = 1
      setTimeout(() => {
        this.$refs.new_email.focus()
      }, 10)
    },
    inputHandlerForPhone: function (e) {
      if (e.key === 'Enter') {
        if (this.change_phone_step === 0) {
          this.request_phone_change()
        } else if (this.change_phone_step === 1) {
          this.confirm_change_phone()
        }
      }
    },
    noop: function (e) {
      console.log('')
    },
    inputHandlerForEmail: function (e) {
      if (e.key === 'Enter') {
        this.request_email_change()
      }
    },
    inputHandlerForName: function (e) {
      if (e.key === 'Enter') {
        this.apply_change_name()
      }
    },
    inputHandlerForLastName: function (e) {
      if (e.key === 'Enter') {
        this.apply_change_lastname()
      }
    },
    start_change_name: function () {
      this.change_name_step = 1
      setTimeout(() => {
        this.$refs.input_ref_name.focus()
      }, 10)
    },
    start_change_lastname: function () {
      this.change_lastname_step = 1
      setTimeout(() => {
        this.$refs.input_ref_lastname.focus()
      }, 10)
    },
    cancel_change_name: function () {
      this.change_name_step = 0
      this.user.personal.name = this.originalUser.personal.name
    },
    cancel_change_lastname: function () {
      this.change_lastname_step = 0
      this.user.personal.surname = this.originalUser.personal.surname
    },
    apply_change_name: function () {
      this.change_name_step = 0
      this.saveUserData()
    },
    apply_change_lastname: function () {
      this.change_lastname_step = 0
      this.saveUserData()
    },
    request_email_change: function () {
      this.$http.post('https://auth.multiplex.ua/ch_email_req', {new_email: this.new_email}).then(response => {
        if (!response.body.err) {
          this.change_email_step = 2
        }
      })
    },
    cancel_change_phone: function () {
      this.change_phone_step = 0
      this.new_phone = ''
      this.wrong_pass = false
    },
    cancel_change_email: function () {
      this.change_email_step = 0
      this.new_email = ''
    },
    savePopupData: function () {
      this.saveUserData()
      this.show_family_popup = false
    },
    editChild: function (index) {
      this.show_family_popup = index
    },
    cancelEditChild: function (index) {
      this.show_family_popup = false
      this.user.family = [...this.originalUser.family]
    },
    addChild: function () {
      this.user.family.push({
        name: '',
        gender: '',
        birthday: ''
      })
      this.show_family_popup = this.user.family.length - 1
    },
    removeChild: function (index) {
      this.user.family.splice(index, 1)
      this.saveUserData()
    },
    resetUserData: function () {
      Store.commit('resetUserToIriginal')
    },
    makeFakeISOString: function (dateStr) {
      var dateArr = dateStr.split('.')
      var date = dateArr[0]
      var month = dateArr[1]
      var year = dateArr[2]
      return year + '-' + month + '-' + date + 'T00:00:00.000Z'
    },
    diffUserData: function () {
      var obj = {}
      for (var field in this.user) {
        if (field !== 'cards') {
          switch (field) {
            case 'personal':
            case 'stuff':
              for (var subfield in this.user[field]) {
                if (this.user[field][subfield] !== this.originalUser[field][subfield]) {
                  if (subfield === 'birthday') {
                    // console.log(this.makeFakeISOString(this.user[field][subfield]))
                    // obj[subfield] = this.user[field][subfield] === '' ? '' : Moment(this.user[field][subfield], 'DD.MM.YYYY').toISOString()
                    obj[subfield] = this.user[field][subfield] === '' ? '' : this.makeFakeISOString(this.user[field][subfield])
                  } else if (subfield === 'family_status') {
                    obj[subfield] = parseInt(this.user[field][subfield])
                  } else {
                    obj[subfield] = this.user[field][subfield]
                  }
                }
              }
              break
            case 'family':
              if (this.user[field].length !== this.originalUser[field].length) {
                obj[field] = ObjectAssignDeep([], this.user[field])
                for (i = 0; i < obj[field].length; i++) {
                  obj[field][i]['birthday'] = obj[field][i]['birthday'] === '' ? '' : Moment(obj[field][i]['birthday'], 'DD.MM.YYYY').toISOString()
                  obj[field][i]['role'] = parseInt(obj[field][i]['role'])
                }
              } else {
                for (var i = 0; i < this.user[field].length; i++) {
                  for (var f in this.user[field][i]) {
                    if (this.user[field][i][f] !== this.originalUser[field][i][f]) {
                      obj[field] = ObjectAssignDeep([], this.user[field])
                      for (i = 0; i < obj[field].length; i++) {
                        obj[field][i]['birthday'] = obj[field][i]['birthday'] === '' ? '' : Moment(obj[field][i]['birthday'], 'DD.MM.YYYY').toISOString()
                        obj[field][i]['role'] = parseInt(obj[field][i]['role'])
                      }
                      break
                    }
                  }
                }
              }
              break
            case 'languages':
              if (this.user[field].length !== this.originalUser[field].length) {
                obj[field] = this.user[field]
              } else {
                for (i = 0; i < this.user[field].length; i++) {
                  if (this.user[field][i] !== this.originalUser[field][i]) {
                    obj[field] = this.user[field]
                    break
                  }
                }
              }
              break
            default:
              for (subfield in this.user[field]) {
                if (this.user[field][subfield] !== this.originalUser[field][subfield]) {
                  if (!obj[field]) {
                    obj[field] = {}
                  }
                  if (subfield === 'city') {
                    obj[field][subfield] = parseInt(this.user[field][subfield])
                  } else {
                    obj[field][subfield] = this.user[field][subfield]
                  }
                }
              }
          }
        }
      }
      return obj
    },
    closeNotify: function () {
      this.notify = false
    },
    saveUserData: function () {
      var diff = this.diffUserData()
      this.notify = false
      setTimeout(() => {
        this.$http.post('/setuserdata', diff).then(response => {
          this.notify = true
          if (!response.body.err) {
            this.notifyState = true
            Store.commit('applyUserFromProfile')
            setTimeout(() => {
              this.notify = false
            }, 4000)
          } else {
            this.notifyState = false
            setTimeout(() => {
              this.notify = false
            }, 4000)
          }
        }, response => {
          this.notifyState = false
          setTimeout(() => {
            this.notify = false
          }, 4000)
        })
      }, 1000)
    },
    dateIsFull: function (d) {
      return d.length === 10
    },
    dateIsValid: function (d) {
      return d.length === 10 && Moment(d, 'DD.MM.YYYY').isValid() || d === ''
    },
    dateIsInPast: function (d) {
      return Moment().diff(Moment(d, 'DD.MM.YYYY')) > 0 || d === ''
    },
    initMP: function (app, data, signature) {
      this.$http.get('https://auth.multiplex.ua/sign/masterpass').then(response => {
        this.mp_active = true
        var data = response.body.master_pass_data
        var signature = response.body.signature
        // this.initMP(this.mpInstance, data, signature)
        this.mpInstance.init({
          data: data,
          signature: signature,
          embedTo: '#masterpass',
          mode: 'embed',
          language: this.uLang === 'ua' ? 'uk' : this.uLang
        }).on('masterpass.ready', function () {
          // alert(123)
        })
      })
    }
  },
  mounted: function () {
    // this.initMP()
  }
}
</script>



// WEBPACK FOOTER //
// profile-page.vue?0aa6b2f7